document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-change-dropdown')) return;

const select = e.target;
const newVariantId = select.value;
const line = select.dataset.line;

const inputQty = document.querySelector('.quantity__input').value;

const productParent = select.closest('.product-description');

let productOption = productParent.querySelector('.product-option dd');

const selectedText = select.options[select.selectedIndex].text;

productOption.innerText = selectedText;
console.warn('inputQty:', inputQty);

  if (!newVariantId || !line) return;

  const cartItem = select.closest('li');
  cartItem?.classList.add('loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(line),
      quantity: 0
    })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: newVariantId,
        quantity: Number(inputQty)
      })
    });
  })
  .then(() => {
    return fetch('/?section_id=mini-cart');
  })
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newMiniCart = doc.querySelector('mini-cart');
    const currentMiniCart = document.querySelector('mini-cart');

    if (newMiniCart && currentMiniCart) {
      currentMiniCart.innerHTML = newMiniCart.innerHTML;
    }
  })
  .catch(err => console.error('Variant swap error:', err));
});


//-----------------------

$(document).ready(function(){

  var slider = $('.cstm_product_slider');

  slider.slick({
    dots:false,
    arrows:true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
    nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    slidesToShow:4,
    slidesToScroll:1,
    responsive:[
      {
        breakpoint:1024,
        settings:{ slidesToShow:3 }
      },
      {
        breakpoint:750,
        settings:{
          slidesToShow:1,
          centerMode:true,
          centerPadding:'120px'
        }
      }
    ]
  });

  // 👇 Image area par swipe kare to card slider disable
  $(document).on('mouseenter touchstart', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', false, true);
  });

  // 👇 Image area se bahar aaye to card slider enable
  $(document).on('mouseleave touchend', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', true, true);
  });

});


(function () {
  const drawerButton = document.querySelector(".bottom-nav-item.cart_drawer_original");
  console.log('1...')
  if (drawerButton) {
    const drawer = document.querySelector("mini-cart");
  console.log('2...')

    if (drawer) {
  console.log('3...')

      drawerButton.addEventListener("click", function(e) {
  console.log('4...')

        e.preventDefault();
        drawer.open();
      });
    }
  }
  const menuDrawerButton = document.querySelector(".bottom-nav-item.menu-drawer-container");
  if (menuDrawerButton) {
    const headerDrawer = document.querySelector("header header-drawer summary");
    if (headerDrawer) {
      menuDrawerButton.addEventListener("click", function(e) {
        e.preventDefault();
        headerDrawer.click();
      });
    }
  }
  
  const loginButton = document.querySelector(".bottom_nav-login-button");
  if (loginButton) {
    loginButton.addEventListener("click", function () {
      if (document.querySelector("#CusloginModal")) document.querySelector("#CusloginModal").style.display = "none";
      if (document.querySelector(".otp_overlay")) document.querySelector(".otp_overlay").style.display = "block";
      if (document.querySelector(".main_otp_container")) document.querySelector(".main_otp_container").style.display = "block";
      window.scrollTo(0,0);
    });
  }
  const walletButton = document.querySelector(".wallet_drawer_original");
  if (walletButton) {
    walletButton.addEventListener("click", function () {
      if (document.querySelector("#CusloginModal")) document.querySelector("#CusloginModal").style.display = "none";
      if (document.querySelector(".otp_overlay")) document.querySelector(".otp_overlay").style.display = "block";
      if (document.querySelector(".main_otp_container")) document.querySelector(".main_otp_container").style.display = "block";
      window.scrollTo(0,0);
    });
  }
})();



document.addEventListener("DOMContentLoaded", function () {
  const productLinks = document.querySelectorAll('#product-grid a[href*="/products/"]');

  productLinks.forEach(link => {
    link.addEventListener("click", function () {
      const card = link.closest('.grid__item');
      if (card && card.id) {
        sessionStorage.setItem("lastProductId", card.id);
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const lastProductId = sessionStorage.getItem("lastProductId");

  if (lastProductId) {
    const el = document.getElementById(lastProductId);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          behavior: "auto",
          block: "center"
        });
      }, 400);
    }

    sessionStorage.removeItem("lastProductId");
  }
});



$(document).ready(function () {
  if ($('.loved_by_celebs_scroll').length) {
    $('.loved_by_celebs_scroll').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
      nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll('.custom-product-video video');
  videos.forEach(video => {
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        document.addEventListener('touchstart', () => {
          video.play();
        }, { once: true });
      });
    }
  });
});



function initProductSliders() {
  document.querySelectorAll('.product-media-wrapper').forEach(wrapper => {

    if (wrapper.classList.contains('slider-initialized')) return;
    wrapper.classList.add('slider-initialized');

    const slideshow = wrapper.querySelector('.product-image-slideshow');
    const images   = slideshow?.querySelectorAll('img') || [];
    const dots     = wrapper.querySelectorAll('.product-dots .dot');

    if (images.length <= 1) {
      if (images.length === 1) images[0].style.opacity = '1';
      return;
    }

    let currentIndex = 0;
    let touchStartX  = 0;
    let autoInterval = null;

    function showSlide(idx) {
      currentIndex = (idx + images.length) % images.length;

      images.forEach((img, i) => {
        img.style.opacity = (i === currentIndex) ? '1' : '0';
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    function next() { showSlide(currentIndex + 1); }
    function prev() { showSlide(currentIndex - 1); }


    wrapper.addEventListener('mouseenter', () => {
      if (autoInterval) clearInterval(autoInterval);
      autoInterval = setInterval(next, 2200);
    });

    wrapper.addEventListener('mouseleave', () => {
      if (autoInterval) {
        clearInterval(autoInterval);
        autoInterval = null;
      }
      showSlide(0);
    });

    wrapper.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;

      if (Math.abs(diff) > 50) {
        diff > 0 ? next() : prev();
      }
    }, { passive: true });

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        showSlide(idx);
        if (autoInterval) {
          clearInterval(autoInterval);
          autoInterval = null;
        }
      });
    });

    showSlide(0);
  });
}

document.addEventListener('DOMContentLoaded', initProductSliders);

const observer = new MutationObserver(() => {
  initProductSliders();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


 
  /*Desktop Thumbnails*/ 
$('.product-slide-slider-js .thumbnail-list').slick({
    dots: false,
    arrow: true,
    vertical: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
   infinite:true,
  watchCss:true,
    asNavFor: '.product-slide-slider-js .product__media-list',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.product-slide-slider-js .product__media-list').slick({
    dots: false,
    arrow: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
     focusOnSelect: true,
     asNavFor: '.product-slide-slider-js .thumbnail-list'
  });
  
  /*End Desktop Thumbnails*/ 
